import { createApp } from 'vue'
import App from './App.vue'
import Maska from 'maska'
import VueCountdown from '@chenfengyuan/vue-countdown'
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'orders',
    component: () => import('./orders/Orders')
  },
  {
    path: '/order',
    name: 'order',
    component: () => import('./orders/Order')
  },
  {
    path: '/documents',
    name: 'documents',
    component: () => import('./documents/Documents')
  },
  {
    path: '/delivery-edit',
    name: 'delivery-edit',
    component: () => import('./delivery/deliveryEdit/DeliveryEdit')
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('./profile/Profile')
  },
  {
    path: '/connect-company',
    name: 'connect-company',
    component: () => import('./connect-company/ConnectCompany')
  },
  {
    path: "/:pathMatch(.*)*",
    component: () => import('./not-found/NotFound')
  },
  {
    path: '/rating/:hash',
    name: 'rating',
    component: () => import('./rating/Rating')
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

const app = createApp(App)
app.component(VueCountdown.name, VueCountdown)
app.directive('focus', {
  mounted (el) {
    el.focus()
  }
})
app.use(Maska)
app.use(router).mount('#app')